import { useEffect, useState } from "react";
import { Icon } from "../components/ui";
import { familyService } from "../services/familyService";
import { fileUrl } from "../config/api";

export default function Policies() {
  const [policies, setPolicies] = useState([]);

  useEffect(() => {
    familyService.getPolicies().then((r) => setPolicies(r?.data || [])).catch(() => {});
  }, []);

  return (
    <div className="page page--wide">
      <div className="policies-card card">
        <span className="icon-circle lg amber"><Icon name="shield" /></span>
        <p className="eyebrow mt-24">Policies</p>
        <h1 className="mt-8">Our centre policies</h1>
        <p className="lead">
          Our policies and fact sheets, all in one place. Tap any policy to open or download the PDF.
        </p>

        {policies.length > 0 ? (
          <div className="policy-links">
            {policies.map((p, i) => (
              <a key={p.id} className="policy-link"
                href={p.file_path ? fileUrl(p.file_path) : "#"}
                target={p.file_path ? "_blank" : undefined} rel="noreferrer">
                <span className="pl-n">{String(i + 1).padStart(2, "0")}</span>
                <span className="pl-main">
                  <span className="pl-t">{p.title}</span>
                  {p.description && <span className="pl-d">{p.description}</span>}
                </span>
                {p.file_label && <span className="form-row-time">{p.file_label}</span>}
                <Icon name={p.file_path ? "download" : "chevronRight"} className="ico-18 ico-soft" />
              </a>
            ))}
          </div>
        ) : (
          <div className="detail-note mt-28">
            <Icon name="bell" className="ico-18 ico-orange" />
            <span>Your centre policies are being added to the portal. We'll let you know the moment they're available here.</span>
          </div>
        )}
      </div>
    </div>
  );
}
